import axios from 'axios';

export const containerStampApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/container-stamp`,
    headers: {
        'Content-Type': 'application/json'
    }
})